/**
 * generateTagularUUID
 *
 * Provides a longform uuid string for tagular.
 *
 * Note: This should not be used on components over the useId hooks.
 * @see @hooks/use-id
 */
const generateTagularUUID = (): string => {
  let date = new Date().getTime();

  if (
    typeof performance !== "undefined" &&
    typeof performance.now === "function"
  ) {
    date += performance.now(); // use high-precision timer if available
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (char) => {
    const value = (date + Math.random() * 16) % 16 | 0;
    date = Math.floor(date / 16);
    return (char === "x" ? value : (value & 0x3) | 0x8).toString(16);
  });
};

export default generateTagularUUID;
